/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportDateRange,
    ReportDateRangeFromJSON,
    ReportDateRangeFromJSONTyped,
    ReportDateRangeToJSON,
    ReportType,
    ReportTypeFromJSON,
    ReportTypeFromJSONTyped,
    ReportTypeToJSON,
    ReportingTimeBucket,
    ReportingTimeBucketFromJSON,
    ReportingTimeBucketFromJSONTyped,
    ReportingTimeBucketToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportRunResponse
 */
export interface ReportRunResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportRunResponse
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportRunResponse
     */
    suggestedFileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportRunResponse
     */
    csvContent?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ReportRunResponse
     */
    generatedAtUtc?: Date;
    /**
     * 
     * @type {ReportingTimeBucket}
     * @memberof ReportRunResponse
     */
    reportingTimeBucket?: ReportingTimeBucket;
    /**
     * 
     * @type {ReportType}
     * @memberof ReportRunResponse
     */
    reportType?: ReportType;
    /**
     * 
     * @type {ReportDateRange}
     * @memberof ReportRunResponse
     */
    reportDateRange?: ReportDateRange;
    /**
     * 
     * @type {string}
     * @memberof ReportRunResponse
     */
    firmName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportRunResponse
     */
    includesPrivilegedUsageColumns?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportRunResponse
     */
    isAllFirmsScope?: boolean;
}

export function ReportRunResponseFromJSON(json: any): ReportRunResponse {
    return ReportRunResponseFromJSONTyped(json, false);
}

export function ReportRunResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportRunResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'suggestedFileName': !exists(json, 'suggestedFileName') ? undefined : json['suggestedFileName'],
        'csvContent': !exists(json, 'csvContent') ? undefined : json['csvContent'],
        'generatedAtUtc': !exists(json, 'generatedAtUtc') ? undefined : (new Date(json['generatedAtUtc'])),
        'reportingTimeBucket': !exists(json, 'reportingTimeBucket') ? undefined : ReportingTimeBucketFromJSON(json['reportingTimeBucket']),
        'reportType': !exists(json, 'reportType') ? undefined : ReportTypeFromJSON(json['reportType']),
        'reportDateRange': !exists(json, 'reportDateRange') ? undefined : ReportDateRangeFromJSON(json['reportDateRange']),
        'firmName': !exists(json, 'firmName') ? undefined : json['firmName'],
        'includesPrivilegedUsageColumns': !exists(json, 'includesPrivilegedUsageColumns') ? undefined : json['includesPrivilegedUsageColumns'],
        'isAllFirmsScope': !exists(json, 'isAllFirmsScope') ? undefined : json['isAllFirmsScope'],
    };
}

export function ReportRunResponseToJSON(value?: ReportRunResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'suggestedFileName': value.suggestedFileName,
        'csvContent': value.csvContent,
        'generatedAtUtc': value.generatedAtUtc === undefined ? undefined : (value.generatedAtUtc.toISOString()),
        'reportingTimeBucket': ReportingTimeBucketToJSON(value.reportingTimeBucket),
        'reportType': ReportTypeToJSON(value.reportType),
        'reportDateRange': ReportDateRangeToJSON(value.reportDateRange),
        'firmName': value.firmName,
        'includesPrivilegedUsageColumns': value.includesPrivilegedUsageColumns,
        'isAllFirmsScope': value.isAllFirmsScope,
    };
}


